import { Component, OnInit, ViewChild } from '@angular/core';
import { AdvanceService } from 'src/app/shared/services/advance.service';
import { TableDataSource } from 'src/app/shared/components/table/table-data-source';
import { Advance } from 'src/app/shared/models/advance.model';
import { MatSort } from '@angular/material/sort';
import { tableSortFn } from 'src/app/shared/utils/sort.util';
import { map } from 'rxjs/operators';
import { UserService } from 'src/app/shared/services/user.service';

@Component({
  selector: 'app-advances-archives',
  templateUrl: './advances-archives.component.html'
})
export class AdvancesArchivesComponent implements OnInit {

  advances$;

  dataSource = new TableDataSource<Advance>();
  @ViewChild(MatSort, { static: false }) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    private advanceService: AdvanceService,
    private userService: UserService
  ) { }

  ngOnInit() {
    const currentUserId = this.userService.getCurrentUserId();
    this.advances$ = this.advanceService.fetchEmployeeInactiveAdvances(currentUserId).pipe(
      map((advances: Advance[]) => {
        this.dataSource.data = advances;
        this.dataSource.sortingDataAccessor = tableSortFn;
        return advances;
      }),
    );
  }

}
